import StringValueObject from "../../../shared/domain/value-object/string-value-object";

export default class AnimePremiered extends StringValueObject {

}